import React from "react";
import {Col, Container, Row} from "react-bootstrap";


class IndicatorPerformanceView extends React.Component {

    constructor(props) {
        super(props);
    }

    getView(){
        let view;
        if(this.props.selectedPosition === null){
            view = <div>Click on Indicator</div>
        } else {
            view =
                <div className="press-grid">
                <Container>
                    <Row>
                        <Col>Time</Col>
                        <Col>Position</Col>
                        <Col>Symbol Values</Col>
                        <Col>Risk Factor</Col>
                        <Col>Points To Risk</Col>
                        <Col>Initial Price</Col>
                        <Col>Threshold </Col>
                        <Col>Duration </Col>
                        <Col>Max Gain Duration </Col>
                        <Col>Max Gain</Col>
                        <Col>Max Gain%</Col>
                    </Row>
                    <Row>
                        <Col>{this.props.selectedPosition.positionStartTime}</Col>
                        <Col>{this.props.selectedPosition.position}</Col>
                        <Col>{this.props.selectedPosition.tickerSymbol}</Col>
                        <Col>{this.props.selectedPosition.riskFactor}</Col>
                        <Col>{this.props.selectedPosition.pointsToRisk}</Col>
                        <Col>{this.props.selectedPosition.initialPrice}</Col>
                        <Col>{this.props.selectedPosition.threshold}</Col>
                        <Col>{this.props.selectedPosition.duration / 1000} seconds</Col>
                        <Col>{this.props.selectedPosition.maxProfitDuration / 1000} seconds</Col>
                        <Col>{this.props.selectedPosition.maxProfit}</Col>
                        <Col>{this.props.selectedPosition.maxProfitPercent}</Col>
                    </Row>
                </Container>
                </div>
        }
        return view;
    }

    render() {
        return (
            this.getView()
        )
    }
}
export {IndicatorPerformanceView}
